<template>
  <div v-if="visible" class="modal-mask">
    <div class="modal-card">
      <button class="modal-close" @click="$emit('close')">×</button>
      <h3>扫码立即下单</h3>
      <p>微信扫码进入小程序预约上门洗车</p>
      <img src="@/assets/placeOrder.png" alt="小程序码" class="modal-qrcode">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close']
}
</script>